// https://stackoverflow.com/questions/57765958/how-to-detect-ipad-and-ipad-os-version-in-ios-13-and-up/57924983#57924983
export const isIOS = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (/Mac/.test(navigator.userAgent) &&
    navigator.maxTouchPoints &&
    navigator.maxTouchPoints > 2)
